import { render, staticRenderFns } from "./ButtonGroupTab.vue?vue&type=template&id=a9ba7104&scoped=true"
import script from "./ButtonGroupTab.vue?vue&type=script&lang=js"
export * from "./ButtonGroupTab.vue?vue&type=script&lang=js"
import style0 from "./ButtonGroupTab.vue?vue&type=style&index=0&id=a9ba7104&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ba7104",
  null
  
)

/* custom blocks */
import block0 from "./ButtonGroupTab.vue?vue&type=custom&index=0&blockType=platform-tab&%3AtabData=tabData&%40tabChange=tabChange"
if (typeof block0 === 'function') block0(component)

export default component.exports